import ArraySortedTreeNode from './lists/ArraySortedTreeNode';

type tickMethod = (dt: number) => void;
export default class GameObject extends ArraySortedTreeNode {
	properties: any;
	tick: tickMethod;

	constructor (properties: any, tick: tickMethod) {
		super();

		this.properties = properties;
		this.tick = tick;
	}

	update (dt: number) {
		// Creating a copy of game objects
		// to make sure that removing game objects within tick does not create side effects
		const gameObjects = this.children.slice();
		for (let c = 0; c < gameObjects.length; c++) {
			const gameObject = gameObjects[c];
			gameObject.tick(dt);
		}

		this.tick(dt);
	}

	onAdded () {};
	onRemoved () {};
	onRepositioned () {};
}

export function generateGameObjectFactory (properties: any, tick: tickMethod) {
	return function generateGameObject () {
		return new GameObject(properties, tick);
	};
}
